import { NextPageContext } from 'next';
import redirectToRoute from './redirectToRoute';
import Routes from '../routes.mjs';
import throw404 from './throw404';

const correctLocalizedRoute = ({
  req, res, query, asPath,
}: {
  req?: NextPageContext['req'] & { locale?: string };
  res?: NextPageContext['res'];
  asPath?: string[] | string ;
  query?: NextPageContext['query'];
}, routePrefix: string) => {
  // eslint-disable-next-line no-underscore-dangle
  const locale = req ? req.locale : window.__NEXT_DATA__.props.locale;

  const route = `${routePrefix}.${locale}`;

  const actualPath = Routes.findAndGetUrls(
    route,
    query,
  ).urls.as;

  // there is no such route for the current locale
  if (route === actualPath) {
    throw404();
  }

  if (asPath !== actualPath) {
    redirectToRoute(route, query, res);
  }
};

export default correctLocalizedRoute;
